module.exports = __webpack_public_path__ + "img/charging-hub-rejected.390c5006.svg";